module.exports = __webpack_public_path__ + "static/media/Gunnison_3 Car.b560fe02.jpg";